import React, {CSSProperties, ReactNode} from 'react'

import {formSpacing} from './styles.js'

export interface FormStackProps {
    /** Vertical space between the items, formSpacing.rowGap by default */
    gap?: number
    style?: CSSProperties
    children?: ReactNode
}

/**
 * Stacks form fields (and FormRows) vertically with the standard spacing between them.
 * Fields have no margins of their own, so all space in a form comes from FormStack and FormRow.
 */
const FormStack = ({gap = formSpacing.rowGap, style, children}: FormStackProps) => {
    return (
        <div style={{display: 'flex', flexDirection: 'column', gap, width: '100%', minWidth: 0, ...style}}>
            {children}
        </div>
    )
}

export default FormStack
